import { useParams } from 'react-router-dom';
import { useQuery } from '@apollo/client';

import {
  CertificateStatus,
  VerifyCertificateDocument,
} from '@sandtech-hub-monorepo/ehub-client';

import { CredentialVerifyView } from '../../components/credentials/CredentialVerifyView';

/** Public: /certificates/verify/:code, where the gateway's verify link lands. */
export const CertificateVerify = () => {
  const { verificationCode } = useParams<{ verificationCode: string }>();
  const { data, loading } = useQuery(VerifyCertificateDocument, {
    variables: { verificationCode: verificationCode ?? '' },
    skip: !verificationCode,
  });
  const certificate = data?.verifyCertificate;
  const revoked = certificate?.status === CertificateStatus.Revoked;

  return (
    <CredentialVerifyView
      kind="certificate"
      loading={loading}
      credential={
        certificate && {
          subjectLabel: 'Program',
          title: certificate.programName ?? certificate.certificateName,
          issuer: certificate.issuer,
          recipientName: certificate.recipientName,
          issuedAt: certificate.issuedAt,
          expiresAt: certificate.expiresAt,
          verificationCode: certificate.verificationCode,
          status: certificate.status,
          isValid: certificate.isValid,
          description: certificate.certificateDescription,
          imageUrl: certificate.imageUrl,
          downloadUrl: certificate.pdfUrl ?? certificate.imageUrl,
          previewUrl: certificate.pdfUrl,
          badgeImageUrl: revoked
            ? certificate.revokedBadgeImageUrl ?? certificate.badgeImageUrl
            : certificate.badgeImageUrl,
        }
      }
    />
  );
};
